module.exports = __webpack_public_path__ + "static/media/bff7.f1946dba.png";